import React from 'react';

import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import CellWrapper from './CellWrapper';
// import IntlText from '../../app/components/IntlText';
// import messages from '../../messages';

const Unit = styled.span`
  color: ${({ theme }) => theme.custom.colors.gray400};
`;

const UnitSmall = styled.span`
  color: ${({ theme }) => theme.custom.colors.gray400};
  font-size: 12px;
  line-height: 20px;
`;

function* getArrayOfProp(array, propName) {
  let index = 0;
  while (index < array.length) {
    const propValue = array[index++].original[propName];
    yield propValue;
  }
}

const getFirstLayerTemp = ({ row, column }) => {
  const firstLayerPropName = `${column.id}_first_layer`;
  if (row.original?.[firstLayerPropName])
    return `${row.original[firstLayerPropName]}`;

  if (!row?.leafRows) return null;

  const firstLayerTemps = [
    ...getArrayOfProp(row.leafRows, firstLayerPropName),
  ].filter(temp => !!temp);

  if (firstLayerTemps.length === 0) return null;

  const min = Math.min(...firstLayerTemps);
  const max = Math.max(...firstLayerTemps);

  return { min, max };
};

/**
 * @todo translate
 */
export function TemperatureValue({ value, row, column }) {
  const translate = useTranslations();

  let min, max;
  const firstLayerTemp = getFirstLayerTemp({ row, column });

  if (typeof value?.min === 'number') {
    if (
      typeof firstLayerTemp === 'object' &&
      firstLayerTemp != null &&
      'min' in firstLayerTemp
    ) {
      min = Math.min(firstLayerTemp.min, value.min);
      max = Math.max(firstLayerTemp.max, value.max);
    } else {
      min = value.min;
      max = value.max;
    }
  }
  if (!value) {
    return <CellWrapper $left={true} style={{ flexDirection: 'column' }} />;
  }

  return (
    <CellWrapper $left={true} style={{ flexDirection: 'column' }}>
      <div>
        {typeof value === 'object' ? `${min}-${max}` : value ?? '-'}{' '}
        <Unit style={{ marginLeft: 3 }}>°C</Unit>
      </div>

      {typeof firstLayerTemp === 'string' && (
        <UnitSmall>
          {`${translate(
            'app-containers-MaterialsPage-firstLayer'
          )}: ${firstLayerTemp}°C`}
        </UnitSmall>
      )}
    </CellWrapper>
  );
}

export function SpeedValue({ value }) {
  if (!value) return null;
  return (
    <CellWrapper>
      {value} <Unit style={{ marginLeft: 3 }}>mm/s</Unit>
    </CellWrapper>
  );
}

export function ForceValue({ value }) {
  if (!value) return null;
  return (
    <CellWrapper>
      {value} <Unit>Mpa</Unit>
    </CellWrapper>
  );
}

export function StrengthValue({ value }) {
  if (!value) return null;
  if (value === -1) {
    return <CellWrapper>no break</CellWrapper>;
  }
  return (
    <CellWrapper>
      {value}{' '}
      <Unit style={{ marginLeft: 3 }}>
        kJ/m<sup>2</sup>
      </Unit>
    </CellWrapper>
  );
}

export function TextValue({ value }) {
  return <CellWrapper>{value}</CellWrapper>;
}
